import { Injectable } from '@angular/core';
import { Subscription, BehaviorSubject, Observable } from 'rxjs';

/**
 * 経過時間を管理するプロバイダー.
 */
@Injectable()
export class TimeProvider {

  /** 1秒(1,000ミリ秒) */
  private readonly ONE_SECOND = 1000;

  /** 経過秒数 */
  public elapsedSeconds: BehaviorSubject<number>;

  constructor() {
    this.elapsedSeconds = new BehaviorSubject(0);
  }

  /**
   * タイマーを開始する.
   */
  public start() {
    Observable
      .interval(this.ONE_SECOND)
      .subscribe((seconds) => this.elapsedSeconds.next(seconds));
  }
}



// WEBPACK FOOTER //
// ./src/providers/time/time.ts